<template>
  <nav class="breadcrumb" aria-label="Breadcrumb">
    <ol
      :class="['breadcrumb-list', `breadcrumb-list--step-${step}`]"
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
    >
      <li
        v-for="(item, index) in steps"
        :key="index"
        :class="['breadcrumb-list__item', { 'is-current': step >= index + 1 }]"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        <span itemprop="item">
          <span itemprop="name">{{ item.name }}</span>
        </span>

        <meta itemprop="position" :content="++index" />
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: ['step'],
  data() {
    return {
      steps: [
        { name: 'Dados cadastrais', route: '/' },
        { name: 'Pagamento', route: '/pagamento' },
        { name: 'Confirmação de Adesão', route: '/confirmacao' }
      ]
    };
  }
};
</script>

<style lang="scss">
.breadcrumb {
  width: 100%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;

  &-list {
    position: relative;
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    justify-content: space-between;

    &:after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      z-index: -1;
      display: block;
      width: 66.5%;
      height: 6px;
      margin-left: auto;
      margin-right: auto;
      background-color: var(--color-gray-medium);
    }

    &--step {
      &-2 {
        &:after {
          background-image: linear-gradient(
            to right,
            var(--color-balanced) 0%,
            var(--color-balanced) 49%,
            var(--color-gray-medium) 50%
          );
        }
      }

      &-3 {
        &:after {
          background-color: var(--color-balanced);
        }
      }
    }

    &__item {
      width: 100%;
      text-align: center;
      font-size: 14px;

      @media (min-width: 768px) {
        font-size: 16px;
      }

      &:after {
        content: '';
        display: block;
        width: 24px;
        height: 24px;
        transform: translateY(10px);
        margin-left: auto;
        margin-right: auto;
        border-radius: 50%;
        background-color: var(--color-gray-medium);
      }

      span {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 100px;
        margin-left: auto;
        margin-right: auto;
      }

      &.is-current {
        &:after {
          background-color: var(--color-balanced);
        }
      }
    }
  }
}
</style>
